import filesize from 'filesize'

// Pixel dimensions for the asset info overlay, e.g. "1600×1094 px".
// Assets without a raster size (text, audio, some documents) have no
// width/height, and width comes back 0 rather than null on some ingests.
export const assetDimensions = (asset = {}) =>
    asset.width && asset.height ? `${asset.width}×${asset.height} px` : null

// The file line under the filename in the grid card's info overlay:
// "1.34 MB · 1600×1094 px". Either part can be absent — dimensions for the
// asset types above, file_size until an upload finishes — so only the parts
// we have are joined, and neither leaves a dangling separator behind.
export const assetFileSummary = (asset = {}) => [
    asset.file_size ? filesize(asset.file_size) : null,
    assetDimensions(asset),
].filter(Boolean).join(' · ')
